import { Box, Button, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import type { InvoiceTransactionDraftDTO } from '@inversor-hub/types';

interface DocumentViewerProps {
  draft: InvoiceTransactionDraftDTO;
}

export const DocumentViewer = ({ draft }: DocumentViewerProps) => {
  const document = draft.document;
  const isImage = document?.mimeType?.startsWith('image/');
  const isPdf = document?.mimeType === 'application/pdf';

  const openInNewTab = () =>
    document?.signedUrl && window.open(document.signedUrl, '_blank', 'noopener,noreferrer');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: 0, gap: 1.5 }}>
      <Box
        sx={{
          minHeight: 240,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
        }}
      >
        {document && isImage && (
          <Box
            component="img"
            src={document.signedUrl}
            alt={document.fileName}
            sx={{
              maxWidth: '100%',
              maxHeight: 420,
              borderRadius: '6px',
              boxShadow: 3,
              border: 1,
              borderColor: 'grey.100',
            }}
          />
        )}
        {document && isPdf && (
          <Box
            component="iframe"
            title={document.fileName}
            src={document.signedUrl}
            sx={{
              width: '100%',
              height: 420,
              border: 1,
              borderColor: 'grey.100',
              borderRadius: '6px',
              bgcolor: 'background.paper',
            }}
          />
        )}
        {(!document || (!isImage && !isPdf)) && (
          <Box
            sx={{
              width: '100%',
              maxWidth: 360,
              bgcolor: 'background.paper',
              borderRadius: '12px',
              border: 1,
              borderColor: 'grey.100',
              boxShadow: 3,
              p: 4,
              textAlign: 'center',
            }}
          >
            <DescriptionOutlinedIcon sx={{ fontSize: 40, color: 'primary.main' }} />
            <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'text.primary', mt: 1 }} noWrap>
              {document?.fileName ?? 'Documento adjunto'}
            </Typography>
            <Typography sx={{ fontSize: 12.5, color: 'text.secondary', mt: 0.5 }}>
              {document ? 'Vista previa no disponible.' : 'No hay documento asociado.'}
            </Typography>
          </Box>
        )}
      </Box>
      {document?.signedUrl && (
        <Button
          size="small"
          variant="outlined"
          startIcon={<OpenInNewIcon />}
          onClick={openInNewTab}
          sx={{ alignSelf: 'center' }}
        >
          Abrir documento
        </Button>
      )}
    </Box>
  );
};
